<!-- eslint-disable vue/no-v-html -->
<template>
	<div
		class="px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
		:class="{ 'py-6': !compact, 'py-3': compact }"
		data-testid="list-item">
		<dt data-testid="label" class="text-sm font-medium leading-5 text-gray-900">
			{{ keyValue }}
		</dt>
		<dd
			data-testid="value"
			class="mt-1 text-sm leading-5 text-gray-700 sm:col-span-2 sm:mt-0 break-words"
			v-html="value"></dd>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import _ from 'lodash'

	const props = withDefaults(
		defineProps<{
			label: string
			value?: any
			format?: boolean
			compact?: boolean
		}>(),
		{
			value: '',
			format: true,
			compact: false
		}
	)

	const keyValue = computed(() => {
		if (props.format === false) {
			return props.label
		}

		return _.capitalize(props.label.replace(/_/g, ' '))
	})
</script>
